<template>
  <div class="sidebar" id="sidebar">
    <div class="sidebar-inner" id="style-15">
      <vue-custom-scrollbar
        class="scroll-area"
        :settings="settings"
        @ps-scroll-x="scrollHanle"
      >
        <div id="sidebar-menu" class="sidebar-menu">
          <ul>
            <!-- Admin  -->
            <template
              v-if="
                userType == userTypeMainAdmin ||
                userType == userTypeSchoolAdmin ||
                (userType == userTypeInstructorSchoolAdmin && isSchoolAdminPage)
              "
            >
              <router-link
                v-if="userType != userTypeMainAdmin"
                :to="{ name: 'schoolAdminMyCalendar' }"
                tag="li"
                :class="$route.path.includes('/mycalendar') ? activeClass : ''"
              >
                <a><i class="la la-calendar"></i><span>My Calendar</span></a>
              </router-link>
              <router-link
                v-if="
                  userType != userTypeMainAdmin &&
                  instructorCountries &&
                  instructorCountries.length
                "
                :to="{ name: 'schoolAdminPublicHoliday' }"
                tag="li"
                :class="
                  $route.path.includes('/publicholiday') ? activeClass : ''
                "
              >
                <a @click="removeSideMenu">
                  <i class="la la-calendar-minus"></i>
                  <span>{{
                    instructorCountries.length > 1
                      ? "Public Holidays in Country of Work"
                      : instructorCountries[0].Name + " Public Holidays"
                  }}</span>
                </a>
              </router-link>
              <router-link
                :to="{
                  name:
                    userType == userTypeMainAdmin
                      ? 'mainAdminDocumentList'
                      : 'schoolAdminDocumentList',
                }"
                tag="li"
                :class="
                  $route.path.includes('/document') &&
                  !$route.path.includes('/student') &&
                  !$route.path.includes('/instructor')
                    ? activeClass
                    : ''
                "
              >
                <a><i class="la la-file-text"></i><span>Documents</span></a>
              </router-link>
              <li class="submenu">
                <a>
                  <i class="la la-school"></i>
                  <span>Classes</span>
                  <span class="menu-arrow"></span>
                </a>
                <ul style="display: none">
                  <router-link
                    :to="{
                      name:
                        userType == userTypeMainAdmin
                          ? 'mainAdminClassSubjectList'
                          : 'schoolAdminClassSubjectList',
                    }"
                    tag="li"
                    :class="
                      $route.path.includes('/classsubject') ? activeClass : ''
                    "
                  >
                    <a><span>List of Class Subjects</span></a>
                  </router-link>
                  <router-link
                    :to="{
                      name:
                        userType == userTypeMainAdmin
                          ? 'mainAdminClassList'
                          : 'schoolAdminClassList',
                    }"
                    tag="li"
                    :class="
                      $route.path == '/mainadmin/class' ||
                      $route.path == '/schooladmin/class' ||
                      $route.path.includes('/class/')
                        ? activeClass
                        : ''
                    "
                  >
                    <a><span>List of Classes</span></a>
                  </router-link>
                  <router-link
                    :to="{
                      name:
                        userType == userTypeMainAdmin
                          ? 'mainAdminClassBookingList'
                          : 'schoolAdminClassBookingList',
                    }"
                    tag="li"
                    :class="
                      $route.path.includes('/classbooking') ? activeClass : ''
                    "
                  >
                    <a><span>Class Bookings</span></a>
                  </router-link>
                </ul>
              </li>
              <router-link
                v-if="userType == userTypeMainAdmin"
                :to="{ name: 'schoolList' }"
                tag="li"
                :class="$route.path.includes('/school') ? activeClass : ''"
              >
                <a><i class="la la-university"></i><span>Schools</span></a>
              </router-link>
              <router-link
                :to="{
                  name:
                    userType == userTypeMainAdmin
                      ? 'mainAdminInstructorList'
                      : 'schoolAdminInstructorList',
                }"
                tag="li"
                :class="$route.path.includes('/instructor') ? activeClass : ''"
              >
                <a>
                  <i class="la la-chalkboard-teacher"></i>
                  <span>Staff</span>
                </a>
              </router-link>
              <router-link
                :to="{
                  name:
                    userType == userTypeMainAdmin
                      ? 'mainAdminStudentList'
                      : 'schoolAdminStudentList',
                }"
                tag="li"
                :class="$route.path.includes('/student') ? activeClass : ''"
              >
                <a>
                  <i class="la la-graduation-cap"></i>
                  <span>Students</span>
                </a>
              </router-link>
              <router-link
                v-if="userType == userTypeMainAdmin"
                :to="{ name: 'mainAdminErrorReport' }"
                tag="li"
                :class="$route.path.includes('/errorreport') ? activeClass : ''"
              >
                <a>
                  <i class="la la-file-invoice"></i>
                  <span>Error Report</span>
                </a>
              </router-link>
            </template>
            <!-- /Admin  -->

            <!-- Instructor -->
            <template
              v-if="
                userType == userTypeInstructor ||
                (userType == userTypeInstructorSchoolAdmin &&
                  !isSchoolAdminPage)
              "
            >
              <router-link
                :to="{ name: 'instructorMyAccount' }"
                tag="li"
                :class="$route.path.includes('/myaccount') ? activeClass : ''"
              >
                <a><i class="la la-user"></i><span>My Account</span></a>
              </router-link>
              <router-link
                :to="{ name: 'instructorMySchedule' }"
                tag="li"
                :class="
                  $route.path.includes('/myschedule') ||
                  $route.path.includes('/classbooking')
                    ? activeClass
                    : ''
                "
              >
                <a><i class="la la-calendar"></i><span>My Schedule</span></a>
              </router-link>
              <router-link
                v-if="instructorCountries && instructorCountries.length"
                :to="{ name: 'instructorPublicHoliday' }"
                tag="li"
                :class="
                  $route.path.includes('/publicholiday') ? activeClass : ''
                "
              >
                <a @click="removeSideMenu">
                  <i class="la la-calendar-minus"></i>
                  <span>{{
                    instructorCountries.length > 1
                      ? "Public Holidays in Country of Work"
                      : instructorCountries[0].Name + " Public Holidays"
                  }}</span>
                </a>
              </router-link>
              <router-link
                :to="{ name: 'instructorMyAssignedClass' }"
                tag="li"
                :class="
                  $route.path.includes('/myassignedclass') ? activeClass : ''
                "
              >
                <a>
                  <i class="la la-school"></i>
                  <span>My Assigned Classes</span>
                </a>
              </router-link>
              <router-link
                :to="{ name: 'instructorMyStudents' }"
                tag="li"
                :class="$route.path.includes('/mystudents') ? activeClass : ''"
              >
                <a>
                  <i class="la la-user-friends"></i><span>My Students</span>
                </a>
              </router-link>
              <router-link
                :to="{ name: 'instructorMyDocuments' }"
                tag="li"
                :class="$route.path.includes('/mydocuments') ? activeClass : ''"
              >
                <a><i class="la la-file-text"></i><span>My Documents</span></a>
              </router-link>
              <router-link
                :to="{ name: 'instructorStudentDocuments' }"
                tag="li"
                :class="
                  $route.path.includes('/studentdocuments') ? activeClass : ''
                "
              >
                <a>
                  <i class="la la-files-o"></i><span>Students' Documents</span>
                </a>
              </router-link>
            </template>
            <!-- Instructor -->

            <!-- Student -->
            <template v-if="userType == userTypeStudent">
              <router-link
                :to="{ name: 'studentMyAccount' }"
                tag="li"
                :class="$route.path.includes('/myaccount') ? activeClass : ''"
              >
                <a><i class="la la-user"></i><span>My Account</span></a>
              </router-link>
              <router-link
                :to="{ name: 'studentClassBookingForm' }"
                tag="li"
                :class="
                  $route.path.includes('/classbookingform') ? activeClass : ''
                "
              >
                <a @click="$store.state.classId = ''">
                  <i class="la la-folder-plus"></i>
                  <span>Class Booking Form</span>
                </a>
              </router-link>
              <router-link
                v-if="studentCountry"
                :to="{ name: 'studentPublicHoliday' }"
                tag="li"
                :class="
                  $route.path.includes('/publicholiday') ? activeClass : ''
                "
              >
                <a @click="removeSideMenu">
                  <i class="la la-calendar-minus"></i>
                  <span>{{ studentCountry + " Public Holidays" }}</span>
                </a>
              </router-link>
              <router-link
                :to="{ name: 'studentMyClasses' }"
                tag="li"
                :class="$route.path.includes('/myclasses') ? activeClass : ''"
              >
                <a><i class="la la-school"></i><span>My Classes</span></a>
              </router-link>
              <router-link
                :to="{ name: 'studentClassAvailability' }"
                tag="li"
                :class="
                  $route.path.includes('/classavailability') ? activeClass : ''
                "
              >
                <a>
                  <i class="la la-calendar"></i>
                  <span>Class Availability</span>
                </a>
              </router-link>
              <router-link
                :to="{ name: 'studentMyDocuments' }"
                tag="li"
                :class="$route.path.includes('/mydocuments') ? activeClass : ''"
              >
                <a><i class="la la-file-text"></i><span>My Documents</span></a>
              </router-link>
            </template>
            <!-- Student -->

            <!-- Other -->
            <template v-if="isUserTypeOther">
              <router-link
                :to="{ name: 'otherMyAccount' }"
                tag="li"
                :class="$route.path.includes('/myaccount') ? activeClass : ''"
              >
                <a><i class="la la-user"></i><span>My Account</span></a>
              </router-link>
              <router-link
                :to="{ name: 'otherMyCalendar' }"
                tag="li"
                :class="$route.path.includes('/mycalendar') ? activeClass : ''"
              >
                <a><i class="la la-calendar"></i><span>My Calendar</span></a>
              </router-link>
              <router-link
                v-if="instructorCountries && instructorCountries.length"
                :to="{ name: 'otherPublicHoliday' }"
                tag="li"
                :class="
                  $route.path.includes('/publicholiday') ? activeClass : ''
                "
              >
                <a @click="removeSideMenu">
                  <i class="la la-calendar-minus"></i>
                  <span>{{
                    instructorCountries.length > 1
                      ? "Public Holidays in Country of Work"
                      : instructorCountries[0].Name + " Public Holidays"
                  }}</span>
                </a>
              </router-link>
              <router-link
                :to="{ name: 'otherMyDocuments' }"
                tag="li"
                :class="$route.path.includes('/mydocuments') ? activeClass : ''"
              >
                <a><i class="la la-file-text"></i><span>My Documents</span></a>
              </router-link>
            </template>
            <!-- Other -->
          </ul>
        </div>
      </vue-custom-scrollbar>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import API from "../../http-common.js";
import config from "../../config.js";
export default {
  components: {
    vueCustomScrollbar,
  },
  data() {
    return {
      settings: {
        suppressScrollX: false,
      },
      activeClass: "active",
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeSchoolAdmin: config.USERTYPE_SCHOOL_ADMIN,
      userTypeInstructor: config.USERTYPE_INSTRUCTOR,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      userTypeStudent: config.USERTYPE_STUDENT,
      instructorCountries: [],
      studentCountry: "",
    };
  },
  computed: {
    userId() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data.Id;
    },
    token() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data.Token;
    },
    userType() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data.UserType;
    },
    isSchoolAdminPage() {
      return this.$route.path.includes("/schooladmin/");
    },
    isUserTypeOther() {
      return (
        this.userType != this.userTypeMainAdmin &&
        this.userType != this.userTypeSchoolAdmin &&
        this.userType != this.userTypeInstructor &&
        this.userType != this.userTypeInstructorSchoolAdmin &&
        this.userType != this.userTypeStudent
      );
    },
  },
  watch: {
    isSchoolAdminPage(val) {
      if (!val && this.userType == this.userTypeInstructorSchoolAdmin)
        this.getInstructorCountries();
    },
  },
  methods: {
    scrollHanle(evt) {
      console.log(evt);
    },
    removeSideMenu() {
      $("html").removeClass("menu-opened");
      $(".sidebar-overlay").removeClass("opened");
      $(".main-wrapper").removeClass("slide-nav");
    },
    getInstructorCountries() {
      let param = {
        Token: this.token,
        Id: this.userId,
      };
      this.$store.state.isLoading = true;
      API.instructor
        .getInstructorCountries(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.instructorCountries = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //for geolocation
    getGeolocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.showError,
          { timeout: 300000, maximumAge: 1800000 }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    },
    showPosition(position) {
      const { latitude, longitude } = position.coords;
      this.$store.state.isLoading = true;
      axios
        .get(
          `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
        )
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.status == 200) {
            this.studentCountry = response.data.address.country;
            this.$store.state.studentCountry = this.studentCountry;
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    showError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          console.error("User denied the request for Geolocation.");
          break;
        case error.POSITION_UNAVAILABLE:
          console.error("Location information is unavailable.");
          break;
        case error.TIMEOUT:
          console.error("The request to get user location timed out.");
          break;
        case error.UNKNOWN_ERROR:
          console.error("An unknown error occurred.");
          break;
        default:
          console.error("An unknown error occurred.");
      }
    },
  },
  created() {
    if (
      this.userType == this.userTypeSchoolAdmin ||
      this.userType == this.userTypeInstructor ||
      this.userType == this.userTypeInstructorSchoolAdmin ||
      this.isUserTypeOther
    ) {
      this.getInstructorCountries();
    } else if (this.userType == this.userTypeStudent) {
      this.getGeolocation();
    }
  },
  mounted() {
    $(document).on("click", "#sidebar-menu a", function (e) {
      if ($(this).parent().hasClass("submenu")) {
        e.preventDefault();
      }
      if (!$(this).hasClass("subdrop")) {
        $("ul", $(this).parents("ul:first")).slideUp(350);
        $("a", $(this).parents("ul:first")).removeClass("subdrop");
        $(this).next("ul").slideDown(350);
        $(this).addClass("subdrop");
      } else if ($(this).hasClass("subdrop")) {
        $(this).removeClass("subdrop");
        $(this).next("ul").slideUp(350);
      }
    });

    //expand any active link on initial load
    window.setTimeout(() => {
      $("#sidebar-menu ul li.active a")
        .parents("li:last")
        .children("a:first")
        .addClass("active")
        .trigger("click");
    }, 500);
  },
};
</script>

<style scoped>
.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100vh - 60px);
  background-color: transparent !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Layout/Sidebar.vue